/** @format */

import Cookies from 'js-cookie';

const SAVED_INSTRUCTOR_EMAIL_KEY = 'saved-instructor-email';

export function getSavedInstructorEmail() {
  return typeof window !== 'undefined' ? Cookies.get(SAVED_INSTRUCTOR_EMAIL_KEY) : null;
}
